import { ApiTabIndex } from '@/Enums/ReportingDashboard/ApiTabIndex.enum';
import { IParsedAdvertiser } from '@/Interfaces/Advertiser.interface';
import { IClientControlOption } from '@/Interfaces/ControlOption.interface';
import { getClientsList } from './reportingDashboard/slice';

type ClientType = IClientControlOption<IParsedAdvertiser>;

export const getAdvertiserListFromClients = (clients: ClientType[] = []) =>
  clients
    .map(client => client.advertisers)
    .flat()
    .filter(record => !!record?.value)
    .sort((a, b) => (a?.label ?? '').localeCompare(b?.label ?? ''));

export const getAdvertisersList = (apiTab: ApiTabIndex | null, clients: ClientType[] = []) => {
  if (apiTab !== null) {
    const mappedClients = getClientsList(apiTab, clients);
    return getAdvertiserListFromClients(mappedClients);
  }

  return getAdvertiserListFromClients(clients);
};
